import React, { useEffect } from 'react';
import { useField } from 'formik';
// import { useTranslation } from 'react-i18next';

import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { numToLetter } from '~/commons/helpers';

const FieldsOrdering = ({
  idx,
  qtnIndex: i,
  restrictEdit = false,
}) => {
  const [, { value, touched }] = useField(`questionSets[${idx}].questions.${i}`);
  const [,, { setValue: setAns }] = useField(`questionSets[${idx}].questions.${i}.answers`);
  // const { t } = useTranslation();
  let { choices } = value;
  const { answers } = value;

  // take out the last empty choice
  if (!restrictEdit && !choices.slice(-1)[0]) {
    choices = choices.slice(0, -1);
  }

  useEffect(() => {
    if (answers.length !== choices.length) {
      // ensure right number of answers
      let a = answers.slice(0, choices.length);

      a.push(...choices.slice(a.length).map(() => '0'));
      // make sure answers are within one of the choices
      a = a.map((k) => (k >= choices.length ? '0' : k.toString()));

      setAns(a);
    }
  }, [choices.length]);
  useEffect(() => {
    if (touched) {
      // reset field when switch from other question format
      setAns(choices.map((c, k) => k.toString()));
    }
  }, []);

  return (
    <div className="row">
      <div className="col">
        <label>Items *</label>
        <FieldArrayIterables
          name={`questionSets[${idx}].questions.${i}.choices`}
          {...restrictEdit ? {} : {
            tail: '',
          }}
        >
          {(c, ii) => (
            <div
              className="form-row align-items-center"
              key={ii}
            >
              <div className="col-auto pb-3">
                {numToLetter(ii, true)}.
              </div>
              <div className="col">
                <FormGroup
                  name={`questionSets[${idx}].questions.${i}.choices.${ii}`}
                  label={null}
                />
              </div>
            </div>
          )}
        </FieldArrayIterables>
      </div>
      <div className="col">
        <label>Order *</label>
        {answers.map((a, ii) => (
          <FormGroup
            key={ii}
            name={`questionSets[${idx}].questions.${i}.answers.${ii}`}
            as="select"
            label={null}
          >
            {choices.map((c, iii) => (
              <option
                key={iii}
                value={iii}
              >{c}</option>
            ))}
          </FormGroup>
        ))}
      </div>
    </div>
  );
};

export default FieldsOrdering;
